import ContactForm from './ContactForm';
import SliderShopify from './shopify/SliderShopify';
import ShopifyPricing from '././shopify/ShopifyPricing';
import Footer from './footer';
import BackButton from './backButon';
import { SiemCalculator } from './siem/SiemCalculator';
import WebflowTabs from './webflowTabs/WebflowTabs';
import { getCompanyData } from './helpers/directus';
import { ClaritySession } from './clarity/claritySession';

interface IWebflowLiblary {
    ContactForm: typeof ContactForm;
    SliderShopify: typeof SliderShopify;
    Footer: typeof Footer;
    BackButton: typeof BackButton;
    SiemCalculator: typeof SiemCalculator;
    WebflowTabs: typeof WebflowTabs;
    ClaritySession: typeof ClaritySession;
    f: {
        getCompanyData: typeof getCompanyData;
    };
}

const webflowLiblary = {
    ContactForm,
    ShopifyPricing,
    SliderShopify,
    Footer,
    BackButton,
    SiemCalculator,
    WebflowTabs,
    ClaritySession,
    f: {
        getCompanyData,
    },
};

export { IWebflowLiblary, webflowLiblary };
